function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { dateToIso } from '@paperstac/helpers/lib/dateHelpers';
import { getOrdinal } from '@paperstac/helpers/lib/numberHelpers';
import PropTypes from 'prop-types';
import React from 'react';
import Box from '../Box';
import Flex from '../Flex';
import Select from './Select';
const monthOptions = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'].reduce((options, label, index) => {
  options.push({
    label,
    value: "".concat(index + 1).padStart(2, '0')
  });
  return options;
}, []);
const dayOptions = [];
for (let i = 1; i <= 31; i++) {
  dayOptions.push({
    label: getOrdinal(i),
    value: "".concat(i).padStart(2, '0')
  });
}
const getYearOptions = (minYear, maxYear) => {
  const options = [];
  for (let i = minYear; i <= maxYear; i++) {
    options.push({
      label: i,
      value: i
    });
  }
  return options;
};
const DateSelect = /*#__PURE__*/React.memo(_ref => {
  let {
    field,
    maxYear,
    minYear,
    value,
    ...props
  } = _ref;
  const initialValues = field && field.value ? dateToIso(field.value).split('-') : value || '';
  const name = field ? field.name : props.name;
  const onChange = field ? field.onChange : props.onChange;
  const [year, setYear] = React.useState(Array.isArray(initialValues) ? initialValues[0] : '');
  const [month, setMonth] = React.useState(Array.isArray(initialValues) ? initialValues[1] : '');
  const [day, setDay] = React.useState(Array.isArray(initialValues) ? initialValues[2] : '');
  const yearOptions = React.useMemo(() => getYearOptions(minYear, maxYear), [minYear, maxYear]);
  React.useEffect(() => {
    const value = year && month && day ? "".concat(year, "-").concat(month, "-").concat(day) : '';
    const event = {
      target: {
        name,
        value
      }
    };
    onChange && onChange(event);
  }, [name, year, month, day, onChange]);
  React.useEffect(() => {
    if (!field.value) return;
    const [year, month, day] = field.value.split('-');
    setYear(year);
    setMonth(month);
    setDay(day);
  }, [field.value]);
  return /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Box, {
    mr: 1,
    flex: 1
  }, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
    value: month,
    onChange: _ref2 => {
      let {
        target: {
          value
        }
      } = _ref2;
      return setMonth(value);
    }
  }, props), /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Month"), monthOptions.map(_ref3 => {
    let {
      label,
      value
    } = _ref3;
    return /*#__PURE__*/React.createElement("option", {
      key: value,
      value: value
    }, label);
  }))), /*#__PURE__*/React.createElement(Box, {
    mr: 1
  }, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
    value: day,
    onChange: _ref4 => {
      let {
        target: {
          value
        }
      } = _ref4;
      return setDay(value);
    }
  }, props), /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Day"), dayOptions.map(_ref5 => {
    let {
      label,
      value
    } = _ref5;
    return /*#__PURE__*/React.createElement("option", {
      key: value,
      value: value
    }, label);
  }))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Select, _extends({}, field, {
    value: year,
    onChange: _ref6 => {
      let {
        target: {
          value
        }
      } = _ref6;
      return setYear(value);
    }
  }, props), /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Year"), yearOptions.map(_ref7 => {
    let {
      label,
      value
    } = _ref7;
    return /*#__PURE__*/React.createElement("option", {
      key: value,
      value: value
    }, label);
  }))));
});
DateSelect.propTypes = {
  minYear: PropTypes.number,
  maxYear: PropTypes.number
};
DateSelect.defaultProps = {
  minYear: new Date().getFullYear() - 50,
  maxYear: new Date().getFullYear() + 50
};
DateSelect.displayName = 'DateSelect';
export default DateSelect;